// Plan types
export const ETHERNET_PLAN_TYPE = "BROADBAND_FIBER";
export const FIBER_PLAN_TYPE = "BROADBAND_FTTH";

// Product codes (still used outside the venue catalog)
export const PRODUCT_CODES = {
  ethernet: "DL_Ethernet_1Gig_Internet_[1_Month_Recurring_69.00]",
  fiber: "DL_Fiber_1Gig_Internet_[1_Month_Recurring_69.00]"
};

// Ethernet Pricing
export const BOINGO_ETHERNET_AMOUNT = 69;
export const BOINGO_ETHERNET_DISCOUNTED_AMOUNT_OFF = 15;
export const BOINGO_ETHERNET_DISCOUNTED_PRICE = 54;

// Promo data
export const DEFAULT_PROMO_DURATION_MONTHS = "1";
export const AFMTHM_PROMO_CODE = "MTHM15";

/**
 * Display-only plan content for pages with no venue in the URL (e.g. `/`).
 * Not a selectable venue — never added to the dropdown catalog.
 */
export const ETHERNET_PLAN_DISPLAY_DEFAULTS = {
  plan_name: "1 gigabit",
  plan_price: BOINGO_ETHERNET_AMOUNT,
  promo: null,
  module_content: {
    header_text:
      "Introducing the amazing new internet service exclusively in the dorms and barracks.",
    amazon_offer: null,
    amazon_offer_footer: null,
    plan_list_text: [
      "Speeds up to 1 gig - download and upload",
      "No data caps or throttling",
      "Use your own router",
      "Instant on",
    ],
    router_specs_list_text: [
      "Supports gigabit wired speeds",
      "Wi-Fi 5 (802.11ac) or Wi-Fi 6 (802.11ax)",
      "80Mhz channel width",
      "Minimum WPA2 Security",
    ],
  },
};

// Storefront data
export const STOREFRONT_CONTENT = {
  HEADER_TEXT: "Need equipment to get connected?",
  SUB_HEADER_TEXT: "Cable companies charge big monthly fees for their equipment. Boingo Fiber is different. Our ”BYO” plan means you use your own equipment, which saves you a bundle.",
  PRE_LIST_TEXT: "You′re welcome to use any router that meets these specs:",
  LIST_TEXT: [
    "Supports gigabit wired speeds",
    "Wi-Fi 5 (802.11ac) or Wi-Fi 6 (802.11ax)",
    "80Mhz channel width",
    "Minimum WPA2 Security",
  ],
  POST_LIST_TEXT: "These are a few that we′ve found online that are compatible with the Boingo Fiber network. Please note that we do not endorse these products and we don't receive any payment if you purchase from these links.",
  BUY_NOW_TEXT: "BUY NOW:",
  ROUTER_MODELS: [
    {
      name: "TP-Link AX10",
      links: [
        {
          name: "amazon",
          niceName: "Amazon",
          link: "https://a.co/d/9A63qgu",
        },
        {
          name: "exchange",
          niceName: "Exchange",
          link: "https://www.shopmyexchange.com/tp-link-archer-ax1500-wifi-6-router/2788155",
        },
        {
          name: "walmart",
          niceName: "Walmart",
          link: "https://www.walmart.com/ip/TP-LINK-AX1500-Dual-Band-Gigabit-WI-Fi-6-Router/208946195?classType=REGULAR&from=%2Fsearch&sid=7c2f8eca-41b2-48f8-87a8-43013805dde0",
        }
      ]
    },
    {
      name: "TP-Link AX21",
      links: [
        {
          name: "amazon",
          niceName: "Amazon",
          link: "https://a.co/d/4LS4tdb"
        },
        {
          name: "bestbuy",
          niceName: "Best Buy",
          link: "https://www.bestbuy.com/site/tp-link-archer-ax20-ax1800-dual-band-wi-fi-6-router-black/6442841.p?skuId=6442841"
        },
        {
          name: "target",
          niceName: "Target",
          link: "https://www.target.com/p/tp-link-wi-fi-6-router-ax1800-smart-wi-fi-router-archer-ax21-dual-band-gigabit-router-black-manufacturer-refurbished/-/A-89926725#lnk=sametab"
        },
        {
          name: "walmart",
          niceName: "Walmart",
          link: "https://www.walmart.com/ip/TP-Link-WiFi-6-Router-AX1800-Smart-WiFi-Router-Archer-AX21-Dual-Band-Gigabit-Router-Works-with-Alexa-A-Certified-for-Humans-Device/273399421?classType=REGULAR&athbdg=L1600&from=/search"
        }
      ]
    },
    {
      name: "ASUS AX1800",
      links: [
        {
          name: "amazon",
          niceName: "Amazon",
          link: "https://a.co/d/aPmgs0s"
        },
        {
          name: "bestbuy",
          niceName: "Best Buy",
          link: "https://www.bestbuy.com/site/asus-rt-ax55-ax1800-dual-band-wi-fi-6-router-black/6453040.p?skuId=6453040"
        },
        {
          name: "walmart",
          niceName: "Walmart",
          link: "https://www.walmart.com/ip/ASUS-RT-AX55-AX1800-Dual-Band-WiFi-6-Gigabit-Router-802-11ax-Lifetime-internet-security-Parental-Control-Mesh-support-MU-MIMO-OFDMA-4-LAN-Ports-Beamf/235942790?classType=REGULAR&athbdg=L1700&from=%2Fsearch&sid=30f9ade3-601f-4bf4-8ab5-ff4a0ec919e0"
        }
      ]
    },
    {
      name: "Linksys MR7350",
      links: [
        {
          name: "amazon",
          niceName: "Amazon",
          link: "https://a.co/d/hn0aksY"
        },
        {
          name: "exchange",
          niceName: "Exchange",
          link: "https://www.shopmyexchange.com/linksys-max-stream-mesh-wi-fi-6-router-mr7350/2727036"
        },
        {
          name: "walmart",
          niceName: "Walmart",
          link: "https://www.walmart.com/ip/Linksys-Max-Stream-IEEE-802-11ax-Ethernet-Wireless-Router-2-40-GHz-ISM-Band-5-UNII-2-x-Antenna-2-External-225-MB-s-Speed-4-Network-Port-1-Broadband-U/249999874?classType=REGULAR&from=%2Fsearch&sid=293d7457-d265-476d-9e68-355e071222bd"
        }
      ]
    },
    {
      name: "TP-Link AX3000",
      links: [
        {
          name: "amazon",
          niceName: "Amazon",
          link: "https://a.co/d/eglD25F"
        },
        {
          name: "bestbuy",
          niceName: "Best Buy",
          link: "https://www.bestbuy.com/site/tp-link-archer-ax3000-pro-dual-band-wi-fi-6-router-black/6502056.p?skuId=6502056"
        },
        {
          name: "exchange",
          niceName: "Exchange",
          link: "https://www.shopmyexchange.com/tp-link-ax3000-dual-band-gigabit-wi-fi-6-router/2796432"
        },
        {
          name: "target",
          niceName: "Target",
          link: "https://www.target.com/p/tp-link-ax3000-wifi-6-dual-band-router/-/A-79847621#lnk=sametab"
        },
        {
          name: "walmart",
          niceName: "Walmart",
          link: "https://www.walmart.com/ip/TP-Link-Archer-AX3000-4-Stream-Dual-Band-WiFi-6-Wireless-Router-up-to-3-Gbps-Speeds/100797162?classType=REGULAR&from=%2Fsearch&sid=5d0ee83a-a06f-47ea-85cf-38a1a127d9bc"
        }
      ]
    },
    {
      name: "TP-Link Wi-Fi 7",
      links: [
        {
          name: "amazon",
          niceName: "Amazon",
          link: "https://a.co/d/5OpBIbQ"
        },
        {
          name: "walmart",
          niceName: "Walmart",
          link: "https://www.walmart.com/ip/BE3600-Wi-Fi-7-Router/7360472949?classType=REGULAR&from=/search"
        }
      ]
    }
  ],
  ADDITIONAL_ROUTER_HEADER_TEXT: "Additional router options:",
  ADDITIONAL_ROUTER_LIST_TEXT: [
    "TP-Link AC1200",
    "TP-Link AXE5400"
  ],
  SIGNUP_POST_TEXT: "Just bring your own router and get in the fast lane!"
};
